<template>
    <v-dialog :loading="loading" v-model="localdialog" content-class="jobapplyDialog" @click:outside="closeDialog" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card outlined max-height="640">
            <v-card-title>Apply to {{job.title}}<v-spacer></v-spacer><v-icon @click="closeDialog" color="primary">mdi-close</v-icon></v-card-title>
            <v-card-text>
                <v-form ref="applyref" lazy-validation class="bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="apply" >

                    <v-text-field validate-on-blur v-model="application.name" :error-messages="applicationErrors.name" label="Name" type="text" required="true"></v-text-field>
                    <v-text-field validate-on-blur :rules="emailRules" v-model="application.email" :error-messages="applicationErrors.email" label="Email" type="email" required="true"></v-text-field>

                    <UserFiles :baseurl="baseurl" :selectable="true" @selectFile="selectFile" :key="'selectFile'+selectFile"></UserFiles>
                </v-form>   
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn @click="apply" color="primary" :disabled="!application.file_id"><v-icon>mdi-send</v-icon>Submit Application</v-btn>
            </v-card-actions>
        </v-card>  
    </v-dialog>
</template>
<script>
import UserFiles from '@/Shared/UserFiles'
export default {
  props: {
    user: Object,
    errors: Object,
    state: String,
    dialog: Boolean,
    job: Object,
    baseurl: String,
  },
  components: {
      UserFiles
    },
  data() {
    return {
        localdialog: this.dialog,
        application: this.$inertia.form({
          name: (this.user.first_name || this.user.last_name) ? this.user.first_name + ' ' + this.user.last_name : '',
          email: this.user.email,
          file_id: null,
          job_id: this.job.id
        }),
        
        applicationErrors: {
          email: null,
          name: null
        },
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        loading:false
    }
  },
  computed: {
    
  },
  watch: {
    dialog: {
        handler () {
          this.localdialog = this.dialog
        },
        deep: true,
      },
   
    },
  methods: {
    selectFile(f) {
        console.log('file selected',f)
        if (f)
          this.application.file_id = f.id
        else
          this.application.file_id = null
    },
    apply() {
        this.loading = true;
        this.application.post(this.baseurl+'/job/apply', {
        onSuccess: (res) => {
            console.log('success!')
            this.loading=false
            this.$emit('applysuccess',this.job)
        },
        onError: (res) => {
            this.applicationErrors.email = (res && res.email) ? res.email : ''
            this.applicationErrors.name = (res && res.name) ? res.name : ''
            this.applicationErrors.file_id = (res && res.file_id) ? res.file_id : ''
            this.applicationErrors.job_id = (res && res.job_id) ? res.job_id : ''
            this.loading=false
        },
      })
    },
    closeDialog() {
      this.$emit('close');
    },

    getErrors(s) {
      if (this.errors)
        console.log('get errors',s,this.errors,this.errors[s])
        if (this.errors && this.errors[s])
            return this.errors[s]
        else
            return ""
    }
  }
  
}
</script>